import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';

const Footer = styled.div`
  display: flex;
  justify-content: center;
  padding: var(--spacing-04) var(--spacing-05);
`;

const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
  padding: calc(0.625rem - 3px) var(--spacing-05);
`;

interface Props {
  onClick: () => void;
}

export const FilterPopoverDone: FC<Props> = ({ onClick }) => {
  return (
    <Footer>
      <StyledButton
        type="tertiary"
        onClick={onClick}
        data-cy="filters.popover.done"
      >
        {useTranslation('done')}
      </StyledButton>
    </Footer>
  );
};
